import { MarkdownContent } from "@/components/MarkdownContent";
import { Card } from "@/components/ui/card";
import type { BizminerPillarInsight } from "@/types/serializers";
import { withFunctionalInsightLayout } from "./withFunctionalInsightLayout";

interface OverviewProps {
  pillar_insight: BizminerPillarInsight;
  category_id: string;
  current_tab: string;
}

function Overview({ pillar_insight, category_id }: OverviewProps) {
  const category = pillar_insight.analysis?.categories?.find(
    (c) => c.id === category_id,
  );

  return (
    <div className="space-y-6">
      <Card className="p-6">
        <MarkdownContent
          content={category?.insights?.overview || "No overview content available."}
        />
      </Card>
    </div>
  );
}

Overview.layout = withFunctionalInsightLayout;

export default Overview;
